import { render, staticRenderFns } from "./PlatformTerms.vue?vue&type=template&id=7a9315d2&"
import script from "./PlatformTerms.vue?vue&type=script&lang=ts&"
export * from "./PlatformTerms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports